import { TEventLogStoreState } from './types';

export function getEventLogs(state: TEventLogStoreState) {
  return state.eventLogs;
}

export function getSeverities(state: TEventLogStoreState) {
  return state.severities;
}

export function getModules(state: TEventLogStoreState) {
  return state.modules;
}

export function getEntityTypes(state: TEventLogStoreState) {
  return state.entityTypes;
}
